import React from "react";
import { Badge, Button, Col, Container, Row } from "react-bootstrap";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import LogButton from "../../../../../components/atoms/LogButton";
import styled from "styled-components";
import { COLOR_PRIMARY } from "../../../../../constants/Colors";
const BadgeLog = styled.div`
  width: 40px;
  height: 40px;
  border: 2px solid ${COLOR_PRIMARY};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  line-height: 1;
  margin: 0;
  padding: 0;
`;

function NewTomador({ searchTrip = false, handleClose = () => {} }) {
  const history = useHistory();
  const steps = [
    {
      number: 1,
      description: "Completá tu perfil",
      buttonLabel: "Perfil",
      link: "/app/profile",
    },
    {
      number: 2,
      description: "Agregá tus camiones",
      buttonLabel: "Camiones",
      link: "/app/my-units/new-unit-form?type=truck",
    },
    {
      number: 3,
      description: "Sumá tus acoplados",
      buttonLabel: "Acoplados",
      link: "/app/my-units/new-unit-form?type=semi",
    },
    {
      number: 4,
      description: "¡Buscá tu primer viaje!",
      buttonLabel: "Viajes",
      link: "/app/my-travls-to-work",
    },
  ];
  return (
    <Container className="d-flex flex-column align-items-center justify-content-center ">
      <Row className="text-center mb-4 pb-4">
        <Col>
          {searchTrip ? (
            <h1 className="text-primary h3 font-weight-bold">
              Para ofertar primero debes completar los siguientes pasos:
            </h1>
          ) : (
            <h1 className="text-primary h3 font-weight-bold">
              ¡Completá estos pasos y empezá a mover tu camión!
            </h1>
          )}
        </Col>
      </Row>
      {steps.map((step, index) => (
        <Container className="mb-5" key={index} style={{ maxWidth: "500px" }}>
          <Row className="justify-content-center  align-items-center mb-2 ">
            <p className="mr-4 mb-0 h5 font-weight-bold text-primary">
              {step.number}
            </p>
            <LogButton
              variant="primary"
              onClick={() => {
                searchTrip && step.number === 4
                  ? handleClose()
                  : history.push(step.link);
              }}
              title={step.description}
              border="curve"
              style={{ width: "200px" }}
            />
          </Row>
        </Container>
      ))}
    </Container>
  );
}

export default NewTomador;
